// The preset library for visualizers/preset.js - one JSON file per preset,
// each with a `doc` line saying what it is. The order here is the order
// ?presetlist=1 and the debug names use.
import tunnel from './tunnel.json' with { type: 'json' };
import vortex from './vortex.json' with { type: 'json' };
import bloom from './bloom.json' with { type: 'json' };
import drift from './drift.json' with { type: 'json' };
import spiral_galaxy from './spiral-galaxy.json' with { type: 'json' };
import breathing_star from './breathing-star.json' with { type: 'json' };
import shear from './shear.json' with { type: 'json' };
import mirror_hall from './mirror-hall.json' with { type: 'json' };
import warp_nebula from './warp-nebula.json' with { type: 'json' };
import corkscrew from './corkscrew.json' with { type: 'json' };
import pulse_grid from './pulse-grid.json' with { type: 'json' };
import liquid_lens from './liquid-lens.json' with { type: 'json' };
import invert_strobe from './invert-strobe.json' with { type: 'json' };
import slow_burn from './slow-burn.json' with { type: 'json' };
import kaleido_compass from './kaleido-compass.json' with { type: 'json' };
import droste from './droste.json' with { type: 'json' };

export const PRESETS = [tunnel, vortex, bloom, drift, spiral_galaxy, breathing_star, shear, mirror_hall, warp_nebula, corkscrew, pulse_grid, liquid_lens, invert_strobe, slow_burn, kaleido_compass, droste];
export const PRESET_BY_NAME = {};
for (const p of PRESETS) PRESET_BY_NAME[p.name] = p;
